exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PickNumber__areaCode{font-size:1.2rem;font-weight:bold;padding-right:5px}.PickNumber__box{border:1px solid #000;padding:12px;text-decoration:none}.PickNumber__box:hover{text-decoration:none;background:#ffff5c;border-color:#ffff5c}", ""]);

// exports
